"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StocksRoutes = void 0;
const route_1 = require("../route");
class StocksRoutes extends route_1.Route {
    constructor() {
        super('stocks');
    }
    getAccountStatus() {
        return this.get('/account/status');
    }
    getAccount() {
        return this.get('/account');
    }
    createAccount() {
        return this.post('/account/create');
    }
    getSymbolInfo(symbol) {
        return this.get(`/info/${symbol}`);
    }
    getAllSymbols() {
        return this.get('/symbols');
    }
    searchSymbol(param) {
        return this.get('/search', { param });
    }
    getStockQuote(symbol) {
        return this.post('/instruments/quote', { symbol });
    }
    initializePurchase(amount, symbol) {
        return this.post('/purchase/initialize', { amount, symbol });
    }
    executePurchase(tradeId) {
        return this.post(`/purchase/execute/${tradeId}`);
    }
    initializeSell(amount, symbol, quantity) {
        return this.post('/sell/initialize', { amount, symbol, quantity });
    }
    executeSell(tradeId, useQuantity) {
        return this.post(`/sell/execute/${tradeId}`, { useQuantity });
    }
    getPriceHistory(symbol, window) {
        return this.get('/historical_prices', { symbol, window });
    }
    getStatements(type, from, to) {
        return this.get('/account/statements', { type, from, to });
    }
    getStatementDocument(fileKey) {
        return this.get(`/account/statement/${fileKey}`);
    }
}
exports.StocksRoutes = StocksRoutes;
//# sourceMappingURL=stocks.js.map